module.exports = __webpack_public_path__ + "static/media/Rectangle26.019fe036.png";